module.exports = __webpack_public_path__ + "img/orbiter.0618f9ca.png";